const appInfo = {
    title: 'Yatirimi'
};
export default appInfo;

